import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export type FactoryDashboardState = {
    summary: FactoryDashboardSummary | null;
    queue: PaginatedQueue | null;
    queueLoading: boolean;
};

export const factoryDashboardInitialState: FactoryDashboardState = {
    summary: null,
    queue: null,
    queueLoading: false,
};

export const slice = createSlice({
    name: 'factoryDashboard',
    initialState: factoryDashboardInitialState,
    reducers: {
        setDashboardSummaryAction(
            state,
            { payload }: PayloadAction<FactoryDashboardSummary | null>,
        ) {
            state.summary = payload;
        },
        setDashboardQueueAction(
            state,
            { payload }: PayloadAction<{ data: PaginatedQueue | null; append?: boolean }>,
        ) {
            if (payload.append && state.queue && payload.data) {
                state.queue = {
                    ...payload.data,
                    content: [
                        ...(state.queue.content ?? []),
                        ...(payload.data.content ?? []),
                    ],
                };
            } else {
                state.queue = payload.data;
            }
        },
        setQueueLoading(state, action: PayloadAction<boolean>) {
            state.queueLoading = action.payload;
        },
    },
});

export const {
    setDashboardSummaryAction,
    setDashboardQueueAction,
    setQueueLoading,
} = slice.actions;

export default slice.reducer;

